import { Link as OriginalLink } from 'react-router-dom';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Link: FunctionComponent<Props> = ({
    children,
    className = '',
    isDisabled = false,
    onClick,
    target,
    testId = TEST_ID,
    text = '',
    to = ''
}) => {
    const linkTo = /^https?:\/\//.test(to) ? to : { pathname: to };
    const disabledClass = isDisabled ? styles.disabled : '';

    return (
        <OriginalLink
            className={`${className} ${styles.link} ${disabledClass}`}
            data-testid={testId}
            onClick={onClick}
            target={target}
            to={linkTo}>
            {children || text}
        </OriginalLink>
    );
};

export default Link;
